import { useState, useEffect, useRef } from "react";
import Error from "../error";
import Label from "./lable";
import "./style.css";

const InputTime = ({ s, v, e, setValue }) => {
	const [val, setVal] = useState(v);
	const [error, setError] = useState(e ?? []);
	const [shErr, setErr] = useState(false);

	const isFocused = useRef(false);

	useEffect(() => {
		setVal(v);
	}, [v]);

	const { name, id, disabled = false, onChange, onClick, width, style = {}, type = "text" } = s;
	const inputStyle = { ...style?.input, width: width || style?.input?.width };

	return (
		<div className="skin-input-base input-base input-time" style={style?.input_base}>
			<Label label={s?.label} />
			<div className="time">
				<input
					style={inputStyle}
					id={id}
					type={type}
					name={name}
					value={val}
					disabled={disabled}
					onFocus={() => {
						isFocused.current = true;
					}}
					onBlur={() => {
						isFocused.current = false;
					}}
					onChange={handleChange}
					onClick={handleClick}
				/>
			</div>
			{shErr && error.length > 0 && <Error err={error} style={style?.error} errHandleClick={() => setErr(false)} />}
		</div>
	);

	function handleChange(e) {
		const newValue = e.target.value;
		setVal(newValue);
		setError([]);

		if (onChange) onChange(e.target);
		if (setValue) {
			setValue(name, newValue, type);
		}
	}

	function handleClick(e) {
		if (error.length !== 0 && !shErr) setErr(true);
		if (onClick) onClick(e.target);
	}
};

export default InputTime;
